export function RentValueSectionSkeleton() {
  return (
    <div className="w-full md:px-4 px-2">
      <div className="h-7 w-[420px] max-w-full rounded bg-secondary" />
      <div className="mt-2 h-4 w-80 max-w-full rounded bg-secondary" />
      <div className="mt-4 h-12 rounded-2xl bg-secondary" />

      <div className="mt-4 grid grid-cols-2 gap-10">
        <div className="space-y-2">
          <div className="h-4 w-28 rounded bg-secondary" />
          <div className="h-7 w-24 rounded bg-secondary" />
        </div>
        <div className="space-y-2">
          <div className="h-4 w-40 rounded bg-secondary" />
          <div className="h-7 w-24 rounded bg-secondary" />
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="h-64 rounded-2xl bg-secondary" />
        <div className="h-64 rounded-2xl bg-secondary" />
        <div className="h-64 rounded-2xl bg-secondary" />
        <div className="h-64 rounded-2xl bg-secondary" />
      </div>
    </div>
  );
}
